module.exports = __webpack_public_path__ + "img/p023.025434ed.png";